import { InfiniteMarquee } from 'global-modules';

class MarqueeBanner extends HTMLElement {
  constructor() {
    super();

    this.marquee = this.querySelector('[data-marquee]');
    const options = JSON.parse(this.getAttribute('data-options'));

    new InfiniteMarquee({
      ...options,
      element: this.marquee,
      duplicateCount: this.getDuplicateCount(options.spaceBetween),
    });
  }

  // The library doubles the content once, then appends `duplicateCount` clones of
  // that track — so enough clones are needed to cover the viewport width.
  getDuplicateCount(spaceBetween) {
    const gap = parseInt(spaceBetween, 10) || 0;
    const trackWidth =
      [...this.marquee.children].reduce((width, item) => width + item.offsetWidth + gap, 0) * 2;

    if (!trackWidth) return 3;

    return Math.max(3, Math.ceil(window.innerWidth / trackWidth) + 1);
  }
}

if (!customElements.get('marquee-banner')) {
  customElements.define('marquee-banner', MarqueeBanner);
}